import {get} from 'lodash';

const ACCOUNT_PROPERTIES_ACCESSOR = 'accountContactRole';

export default (roleType, roleModel, accountRoleName, policyRoleName) => {
    const hasPolicyDetails = roleType !== 'account';
    const accountContactRole = hasPolicyDetails ? get(roleModel, ACCOUNT_PROPERTIES_ACCESSOR) : roleModel;
    const accountRoleDetails = get(accountContactRole, accountRoleName);
    const policyRoleDetails = get(roleModel, policyRoleName);
    const fieldGetter = (accountRoleField, policyRoleField) => {
        let retValue = get(accountRoleDetails, accountRoleField);
        if (hasPolicyDetails && policyRoleField) {
            retValue = get(policyRoleDetails, policyRoleField) || retValue;
        }
        return retValue;
    };

    return {
        fieldGetter,
        fieldValueGetter: (accountRoleField, policyRoleField) => {
            const vmNode = fieldGetter(accountRoleField, policyRoleField);
            return vmNode && vmNode.value;
        }
    };
};
